// NPM Imports
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";
import moment from "moment";
import { Draggable } from "react-beautiful-dnd";

// Internal Imports
import { GlobalUtils, OppoUtils } from "../../../utils";
import { PATHS, PIPELINE } from "../../../constants";

// Destructuring
const {
  // DOCUMENT_TYPES,
  DOCUMENT_STATUS_TOOLTIP_HASMAP,
  DOCUMENT_STATUS_LABEL,
} = PIPELINE;

const {
  decideDeadlineDateClassName,
  decideDeadlineDaysCount,
  getDocStatusClassName,
} = OppoUtils;

class KanbanSwimlaneCard extends Component {
  dropdownRef = React.createRef();

  state = {};

  _truncateString = (string, length) => {
    if (string && string.length >= length) {
      return `${string.slice(0, length)}...`;
    }
    return string;
  };

  _getItemStyle = (isDragging, draggableStyle) => ({
    // margin: 0px 6px 10px 10px;
    // boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
    // border: "1px solid white",
    // borderRadius: "6px",
    // width: 94%,
    // padding: "5px 10px",
    // backgroundColor: "white",
    userSelect: "none",
    opacity: "1",

    // some basic styles to make the items look a bit nicer

    // change background colour if dragging
    background: isDragging && "white",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  _decideDocumentStatus = docStatus => {
    if (DOCUMENT_STATUS_LABEL[docStatus]) {
      return (
        <Tooltip
          placement="left"
          align={{
            offset: [3, 0],
          }}
          overlay={DOCUMENT_STATUS_TOOLTIP_HASMAP[docStatus]}>
          <span
            className={`kanbanswimlanecard-${getDocStatusClassName(
              docStatus,
            )} kanban-document-status-label`}>
            {docStatus === "DOCUMENT_CLIENT_SIGNED" ? (
              <FontAwesomeIcon icon={["fas", "check-circle"]} />
            ) : (
              <FontAwesomeIcon icon={["far", "exclamation-triangle"]} />
            )}
          </span>
        </Tooltip>
      );
    }
    return null;
  };

  render() {
    const {
      id,
      title: documentName,
      doc_no: documentNo,
      status: docStatus,
      revision_no: revisionNumber,
      deadline_date: deadlineDate,
      created_by: { name: docOwnerName, image_url: docOwnerProfileImageUrl },
      // type: { name: docTypeName } = {},
    } = this.props.doc;

    const dlDate = GlobalUtils.formatDate(deadlineDate, "lll");
    const currentDate = new Date();
    const deadlineLeftHours = moment(dlDate).diff(
      moment(currentDate),
      "days",
      true,
    );
    return (
      <div
        className="kanbanswimlanecard-wrapper"
        data-test={`kanbanswimlanecard-wrapper-${docStatus}`}>
        <Draggable
          key={id.toString()}
          draggableId={id.toString()}
          index={this.props.index}
          id={id}>
          {(provided, snapshot) => (
            <div
              className="kanbanswimlanecard-item"
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={this._getItemStyle(
                snapshot.isDragging,
                provided.draggableProps.style,
              )}>
              <div className="kanbanswimlanecard-docstatus-wrapper">
                <div className="kanbanswimlanecard-actions">
                  {this._decideDocumentStatus(docStatus)}
                </div>
              </div>
              <Link
                to={`${PATHS.DOCUMENTS_PATH}/${documentNo}`}
                onClick={() =>
                  GlobalUtils.writeDataToLocalStorage(
                    "documentPageSource",
                    "kanban",
                  )
                }>
                <div
                  className="kanbanswimlanecard-doc-headingwrapper"
                  data-test={`kanbanswimlanecard-doc-headingwrapper-${docStatus}`}>
                  <span
                    className="kanbanswimlanecard-doc-fileicon"
                    data-test="kanbanswimlanecard-doc-fileicon">
                    <FontAwesomeIcon icon={["fad", "file-alt"]} />
                  </span>
                  <span className="kanbanswimlanecard-doc-heading">
                    <span
                      className="kanbanswimlanecard-doc-headinglink"
                      data-test="kanbanswimlanecard-doc-headinglink">
                      {this._truncateString(documentName, 25)}
                    </span>
                    <span
                      className="kanbanswimlanecard-doc-subheading"
                      data-test="kanbanswimlanecard-doc-subheading">
                      {documentNo}
                      {revisionNumber > 0 && (
                        <span className="kanbanswimlanecard-document-revision-label">
                          Revision {revisionNumber}
                        </span>
                      )}
                    </span>
                  </span>
                </div>

                <div className="kanbanswimlanecard-meta">
                  <div className="kanbanswimlanecard-metadata">
                    <span
                      className="kanbanswimlanecard-metatitle"
                      data-test="kanbanswimlanecard-metatitle">
                      <span className="ic-meta">
                        <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                      </span>
                      Turn around date
                    </span>
                    {deadlineDate ? (
                      <Tooltip
                        placement="bottom"
                        overlay={decideDeadlineDaysCount(deadlineLeftHours)}
                        align={{
                          offset: [0, -4],
                        }}>
                        <span
                          className={`kanbanswimlanecard-dealline-date ${decideDeadlineDateClassName(
                            deadlineLeftHours,
                          )}`}
                          data-test="kanbanswimlanecard-dealline-date">
                          {GlobalUtils.formatDate(deadlineDate, "ll")}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>

                  <div className="kanbanswimlanecard-pic-wrapper">
                    <Tooltip
                      placement="top"
                      align={{
                        offset: [0, 3],
                      }}
                      overlay={docOwnerName || "-"}>
                      <img
                        data-test="kanbanswimlanecard-pic"
                        className="kanbanswimlanecard-pic"
                        src={docOwnerProfileImageUrl}
                        alt="Document Owner Profile"
                      />
                    </Tooltip>
                  </div>
                </div>
              </Link>
            </div>
          )}
        </Draggable>
      </div>
    );
  }
}

export default KanbanSwimlaneCard;



// WEBPACK FOOTER //
// ./src/components/Kanban/KanbanSwimlaneCard/index.js